import { useDispatch } from "react-redux";
import {serachByCategory,serachByAuthorName} from "../redux/filters/actions";

const SingleBlog = ({singleBlog}) => {
    const dispatch = useDispatch();
    const {id, title, category, author_name, author_avator, publish_date, feature_image} = singleBlog;

    const categoryHandler = (category) => {
        dispatch(serachByCategory(category))
    }
    const nameHandler = (name) => {
        dispatch(serachByAuthorName(name))
    }


    return (
        <div
                className="flex flex-col rounded-lg shadow-lg overflow-hidden"
            >
                <div className="flex-shrink-0">
                    <img
                        className="h-48 w-full object-cover"
                        src={feature_image}
                        alt=""
                    />
                </div>

                <div
                    className="flex-1 bg-white p-6 flex flex-col justify-between"
                >
                    <div className="flex-1">
                        <p className="text-sm font-medium text-indigo-600" onClick={() => categoryHandler(category)}>
                            <span
                                className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
                            >
                                {category}
                            </span>
                        </p>
                        <a href="#" className="block mt-1">
                            <p
                                className="text-xl font-semibold text-gray-900"
                            >
                                {title}
                            </p>
                        </a>
                    </div>
                    <div className="mt-6 flex items-center">
                        <div className="flex-shrink-0">
                            <img
                                className="h-10 w-10 rounded-full"
                                src={author_avator}
                                alt=""
                                onClick={() => nameHandler(author_name)}
                            />
                        </div>
                        <div className="ml-3">
                            <p
                                className="text-sm font-medium text-gray-900 hover:underline" onClick={() => nameHandler(author_name)}
                            >
                                {author_name}
                            </p>
                            <div
                                className="flex space-x-1 text-sm text-gray-500"
                            >
                                <time datetime="2020-03-16"
                                >{publish_date}
                                </time>
                                <span aria-hidden="true">
                                    &middot;
                                </span>
                                <span> 6 min read </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default SingleBlog;